import type { RouteObject } from 'react-router';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/** 알림 공개 라우트(specs/080) — 메일 수신거부. 최소 레이아웃 아래에 조립한다. */
export const notificationRoutes: RouteObject[] = [
  {
    path: 'notification/unsubscribe',
    lazy: page('UnsubscribePage'),
    handle: { title: '알림 수신거부' },
  },
];
